import React from 'react';
export * from './QueryParameterContext';
export * from './StaticPropsContext';
export * from './SearchResultContext';

import { QueryParameterContext } from './QueryParameterContext';
import { StaticPropsContextProvider } from './StaticPropsContext';
import { SearchResultContextProvider } from './SearchResultContext';
import { ProgramCatalogPageInitialProps } from '../data/useProgramCatalogPageProps';

interface ProgramCatalogContextProvider {
  children: React.ReactNode;
  initialProps: ProgramCatalogPageInitialProps;
}

export function ProgramCatalogProvider(props: ProgramCatalogContextProvider) {
  return (
    <StaticPropsContextProvider initialProps={props.initialProps}>
      <QueryParameterContext>
        <SearchResultContextProvider>{props.children}</SearchResultContextProvider>
      </QueryParameterContext>
    </StaticPropsContextProvider>
  );
}
